import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Head } from '@/components/head'
import { TestPaymentPage } from '@/features/test-payment/components/test-payment-page'

// todo: use lazy route
export const Route = createFileRoute('/test-payment/$referralId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { referralId } = Route.useParams()

  return (
    <>
      <Head title="Test Payment" />
      <TestPaymentPage referralId={referralId} />
    </>
  )
}
